import { Box, Button, Container, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Input2 from "components/common/Forms/Input2/InputItem";
import React, { useEffect, useState } from "react";
import { Form } from "./styles";
import * as Yup from "yup";
import { formatYupErrors } from "helpers/formatYupErrors";
import { types } from "context/types/types";
import { startCreate, startUpdate } from "actions/question";
import Toast from "components/common/Popup/Toast";

const MultiSelect = (props) => {
  //** Formulario **/
  //Estado del formulario
  const defaultValues = { question: "", options: [], type: "opcionMultiple", points: 1.0, explanation: "" };
  const [values, setValues] = useState(props.data ?? defaultValues);
  const [error, setError] = useState(null);
  //Estado inicial de cada opcion de la pregunta
  const initialOptionState = {
    title: "",
    isCorrect: false,
  };

  // Sincronizar values cuando props.data cambie (modo edición)
  useEffect(() => {
    if (props.data && props.data.id) {
      setValues(props.data);
    }
  }, [props.data]);

  const handleQuestionChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  //añadir nueva opcion de respuesta
  const addOption = () => {
    setValues({ ...values, options: [...values.options, initialOptionState] });
  };

  const removeOption = (index) => {
    const updatedOptions = values.options.filter((_, i) => i !== index);
    setValues({ ...values, options: updatedOptions });
  };

  const handleOptionChange = (e, index) => {
    const { name, value } = e.target;
    const optionToEdit = values.options;
    if (name === "isCorrect") {
      optionToEdit.forEach((option, idx) => {
        if (idx !== index) {
          option.isCorrect = false;
        }
      });
      optionToEdit[index] = {
        ...optionToEdit[index],
        [name]: value === "true",
      };
    } else {
      optionToEdit[index] = {
        ...optionToEdit[index],
        [name]: value,
      };
    }
    setValues({ ...values, options: optionToEdit });
  };

  //** Validaciones del formulario
  const validationSchema = Yup.object().shape({
    question: Yup.string()
      .required("La pregunta es requerida")
      .min(5, "debe tener al menos 5 caracteres"),
    options: Yup.array()
      .required("Las opciones son requeridas")
      .min(2, "Debe tener al menos dos opciones"),
    points: Yup.number()
      .required("Los puntos son requeridos")
      .min(0.1, "Debe tener al menos 0.1 puntos")
      .max(20, "No puede tener más de 20 puntos"),
  });

  useEffect(() => {
    validationSchema
      .validate(values, { abortEarly: false })
      .then(() => setError(null))
      .catch((err) => {
        setError(err);
      });
  }, [values]);

  const verifyOptions = () => {
    return values.options.find((option) => {
      return option.title === "";
    });
  };

  const verifyOptionChecked = () => {
    return values.options.find((option) => {
      return option.isCorrect === true;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (error === null) {
      const isEditing = props.data && props.data.id;

      props.dispatch({
        type: types.questionStartCreate,
        payload: {},
      });

      // Convertir points a número antes de enviar
      const dataToSend = {
        ...values,
        points: Number(values.points) || 1.0,
      };

      let body;
      if (isEditing) {
        // Modo edición: usar startUpdate
        body = await startUpdate(dataToSend, props.data.id);
      } else {
        // Modo creación: usar startCreate
        body = await startCreate(dataToSend, props.quizId);
      }

      if (body.statusCode) {
        props.dispatch({
          type: types.questionCreateError,
          payload: body.message,
        });
        Toast("error", body.message);
      } else {
        props.dispatch({
          type: types.questionCreateSuccess,
          payload: values,
        });
        Toast("success", isEditing ? "Pregunta actualizada" : body.message);

        // Para modo creación
        if (props.setSelected) {
          props.setSelected(null);
        }
        // Para modo edición (cerrar acordeón)
        if (props.setExpanded) {
          props.setExpanded(false);
        }
        // Refrescar lista de preguntas
        if (props.setFlag) {
          props.setFlag(true);
        }
      }
    }
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Form onSubmit={handleSubmit}>
        <Input2
          name="question"
          placeholder="Pregunta"
          value={values.question}
          onChange={handleQuestionChange}
          errors={error?.inner}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0' }}>
          <Input2
            name="points"
            placeholder="Puntos (máx. 20)"
            type="number"
            step="0.1"
            min="0.1"
            max="20"
            value={values.points}
            onChange={handleQuestionChange}
            errors={error?.inner}
            style={{ width: '150px' }}
          />
          <span style={{ fontSize: '12px', color: '#666', marginLeft: '10px' }}>
            Total del quiz: 20 puntos
          </span>
        </Box>
        <Input2
          name="explanation"
          placeholder="Explicación de la respuesta correcta (opcional)"
          value={values.explanation}
          onChange={handleQuestionChange}
          multiline
          rows={3}
          style={{ margin: '10px 0', width: '100%' }}
        />
        <Button color="primary" variant="contained" onClick={addOption}>
          Agregar Respuesta
        </Button>
        <Box>
          {values.options.map((item, i) => {
            return (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "10px 0px",
                }}
              >
                <Input2
                  name="title"
                  placeholder="Opcion"
                  value={item.title}
                  onChange={(e) => handleOptionChange(e, i)}
                  margin="0px"
                />
                <input
                  name="isCorrect"
                  type="radio"
                  placeholder="Correcto"
                  value={true}
                  onChange={(e) => handleOptionChange(e, i)}
                  checked={item.isCorrect}
                />
                {values.options.length > 2 && (
                  <IconButton
                    size="small"
                    onClick={() => removeOption(i)}
                    sx={{ color: "#f44336", ml: 0.5 }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {error && formatYupErrors(error.inner, "options") && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {formatYupErrors(error.inner, "options").message}
            </span>
          )}
        </Box>
        <Button
          sx={{ margin: "10px 0px" }}
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          disabled={
            !values.question || !!verifyOptions() || !verifyOptionChecked()
          }
        >
          {props.data ? "Actualizar pregunta" : "Añadir pregunta"}
        </Button>
      </Form>
    </Container>
  );
};

export default MultiSelect;
